require("jquery-ui/ui/widgets/autocomplete.js");

function AutoComplete() {
    $("#assetListgoBack").hide();
    $("#assetViewgoBack").hide();
    
    var propertyid = $("#PropertyId").val();
    var projectid = $("#ProjectId").val();
    var locationid = $("#LocationId").val();

    if (propertyid!=0) {
        PopulateLocationDropdown(propertyid, locationid);
    }

    function PopulateLocationDropdown(propId, locId) {
        $.ajax({
            type: "GET",
            url: "LocationFilter",
            data: { propertyId: propId },
            success: function (data) {
                var s = '<option value="0">Please Select a Location</option>';
                for (var i = 0; i < data.length; i++) {
                    s += '<option value="' + data[i].id + '">'+ data[i].path + '</option>';
                }
                $("#locationsDropdown").html(s);
                if (locId != 0 && locId != "") {
                    $('#locationsDropdown option[value="' + locId + '"]').attr("selected", "selected");
                }
            }
        });
    }

    function PopulateAutoAssignSupplier() {
        var categoryId = $("#CategoryId").val();
        var projectId = $("#ProjectId").val();

        $.ajax({
            url: "AutoAssignSupplier",
            type: "POST",
            dataType: "json",
            data: { projectId: projectId, categoryId: categoryId },
            success: function (data) {
                $("#SupplierId").val(data.supplierId);
                $("#supplierSearch").val(data.supplierName);
            }
        })
    }

    $(function () {
        $("#contactSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "contactSearch",
                    type: "POST",
                    dataType: "json",
                    data: { contactSearch: request.term },
                    success: function (data) {
                        $("#ContactId").val('0');
                        response($.map(data, function (item) {                        
                            return { label: item.name, value: item.contactId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#ContactId").val(ui.item.value);
                $("#contactSearch").val(ui.item.label);
                return false;
            }
        });

        $("#projectSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "ProjectSearch",
                    type: "POST",
                    dataType: "json",
                    data: { projectSearch: request.term },
                    success: function (data) {
                        $("#ProjectId").val('0');
                        $("#PropertyId").val('0');
                        $("#propertySearch").val('');
                        $("#locationsDropdown").val('0');
                        response($.map(data, function (item) {
                            return { label: item.name, value: item.projectId, propertyId: item.propertyId, propertyName: item.propertyName };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#ProjectId").val(ui.item.value);
                $("#projectSearch").val(ui.item.label);

                if (ui.item.propertyId != 0 && ui.item.propertyId != null) {
                    $("#PropertyId").val(ui.item.propertyId);
                    $("#propertySearch").val(ui.item.propertyName);

                    PopulateLocationDropdown(ui.item.propertyId);

                    PopulateAutoAssignSupplier();
                }

                return false;
            }
        });

        $("#propertySearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "propertySearch",
                    type: "POST",
                    dataType: "json",
                    data: { propertySearch: request.term },
                    success: function (data) {
                        $("#PropertyId").val('0');
                        $("#locationsDropdown").val('0');
                        response($.map(data, function (item) {        
                            return { label: item.name, value: item.propertyId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#PropertyId").val(ui.item.value);
                $("#propertySearch").val(ui.item.label);

                PopulateLocationDropdown(ui.item.value);

                PopulateAutoAssignSupplier();

                return false;
            }
        });

        $("#supplierSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "SupplierSearch",
                    type: "POST",
                    dataType: "json",
                    data: { supplierSearch: request.term },
                    success: function (data) {
                        $("#SupplierId").val('0');
                        response($.map(data, function (item) {
                            return { label: item.name, value: item.companyId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#SupplierId").val(ui.item.value);
                $("#supplierSearch").val(ui.item.label);
                return false;
            }
        });

        $("#engineerSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "EngineerSearch",
                    type: "POST",
                    dataType: "json",
                    data: { engineerSearch: request.term, supplierId: $("#SupplierId").val() },
                    success: function (data) {
                        $("#EngineerId").val('0');
                        response($.map(data, function (item) {
                            return { label: item.name, value: item.engineerId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#EngineerId").val(ui.item.value);
                $("#engineerSearch").val(ui.item.label);
                return false;
            }
        });

        $("#assetSearch").autocomplete({
            minLength: 3,
            source: function (request, response) {
                $.ajax({
                    url: "assetSearch",
                    type: "POST",
                    dataType: "json",
                    data: { assetSearch: request.term },
                    success: function (data) {
                        $("#AssetId").val('0');
                        response($.map(data, function (item) {
                            return { label: item.assetName, value: item.recordId };
                        }))
                    }
                })
            },
            select: function (event, ui) {
                $("#AssetId").val(ui.item.value);
                $("#assetSearch").val(ui.item.label);
                return false;
            }
        });
    });

    $("#assetListgoBack").click(function () {
        $("#workOrderPlaceHolder").show();
        $("#assetListPlaceHolder").hide();
        $("#assetListgoBack").hide();
        $("#assetViewPlaceHolder").hide();
        $("#saveCancelButtons").show();
    });

    $("#assetViewgoBack").click(function () {
        showAssetList();
    });
}

module.exports = AutoComplete;
